import {DragIndicator, RemoveCircleOutline} from '@mui/icons-material'
import {
  FormControlLabel,
  Grid,
  Button,
  Divider,
  Tooltip,
  IconButton,
  Link,
  Stack,
  MenuItem,
} from '@mui/material'
import HelpIcon from '@mui/icons-material/Help'
import React, {useState} from 'react'
import {AUDIENCE} from '../../../../../utils/constants'
import WbTextField from '../../../../common/WbTextField'
import WbSwitch from '../../../../common/WbSwitch'
import WbFileUpload from '../../../../common/WbFileUpload'
import {MultiOptionImageOption} from './MultipleOptionSubComponent'
import {
  MultiOptionEmojiOption,
  MultiOptionTextOption,
} from './MultipleOptionSubComponent'
import CategoryPicker from '../CategoryPicker'

export default function MultipleSelect({
  survey,
  question,
  updateQuestion,
  onAutoSaveCategory,
  audience,
  isPriority,
}) {
  const [showCategory, setShowCategory] = useState(
    !!(question?.categoryId || question?.categoryName)
  )
  const handleCustomValues = e => {
    let checked = e.target.checked
    let q = question
    q.hasCustomValue = checked

    if (!checked) {
      let options = [...question.multiOptionResponseAttributes]
      options?.map(op => {
        op.customValue = null
        op.pupilCustomValue = null
        op.parentCustomValue = null
      })
      q.options = [...options]
    }
    updateQuestion(q)
  }

  const setOptionType = (text, emoji, image) => {
    updateQuestion({
      ...question,
      isTextOption: text,
      isEmojiOption: emoji,
      isImageOption: image,
      multiOptionResponseAttributes: [
        ...question.multiOptionResponseAttributes,
      ],
      followupQuestions: [...question.followupQuestions],
      questionSettings: {...question.questionSettings},
    })
  }

  const getDivider = () => (
    <div style={{marginLeft: 5, marginRight: 5}}>
      <Divider orientation="vertical" flexIte />
    </div>
  )
  return (
    <>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <WbTextField
            value={
              audience === AUDIENCE.STAFF
                ? question.staffText
                : audience === AUDIENCE.PARENT
                  ? question.parentText
                  : question.pupilText
            }
            label="Enter your question text"
            onChange={e => {
              let q = {
                ...question,
                questionSettings: {...question.questionSettings},
                followupQuestions: [...question.followupQuestions],
                multiOptionResponseAttributes: [
                  ...question.multiOptionResponseAttributes,
                ],
              }
              let text = e.target.value
              if (isPriority) {
                if (audience === AUDIENCE.STAFF) {
                  if (q.pupilText === q.staffText) q.pupilText = text
                  if (q.parentText === q.staffText) q.parentText = text
                  q.staffText = text
                }
                if (audience === AUDIENCE.PARENT) {
                  if (q.pupilText === q.parentText) q.pupilText = text
                  q.parentText = text
                  q.staffText = text
                }
                if (audience === AUDIENCE.STUDENT) {
                  q.pupilText = text
                  q.parentText = text
                  q.staffText = text
                }
              } else {
                if (audience === AUDIENCE.STAFF) q.staffText = text
                if (audience === AUDIENCE.PARENT) q.parentText = text
                if (audience === AUDIENCE.STUDENT) q.pupilText = text
              }
              updateQuestion({
                ...q,
                questionSettings: {...q.questionSettings},
                followupQuestions: [...q.followupQuestions],
                multiOptionResponseAttributes: [
                  ...q.multiOptionResponseAttributes,
                ],
              })
            }}
          ></WbTextField>
        </Grid>
        {showCategory && (
          <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
            <CategoryPicker
              survey={survey}
              question={question}
              updateQuestion={updateQuestion}
              onCategoryAssigned={onAutoSaveCategory}
              disabled={!isPriority}
            />
          </Grid>
        )}

        <Grid item lg={12} md={12} sm={12} xs={12} my={2}>
          <Stack
            direction="row"
            spacing={1}
            justifyContent="end"
            className="meta-text"
          >
            <Link
              href="#"
              underline="hover"
              onClick={e => {
                e.preventDefault()
                setShowCategory(prev => !prev)
              }}
              disabled={!isPriority}
            >
              {showCategory ? 'Hide ' : 'Assign '} Category
            </Link>

            <Divider orientation="vertical" variant="middle" flexItem />
            <Link
              href="#"
              underline="hover"
              onClick={e => {
                e.preventDefault()
                let q = question
                q.hasDescription = !q.hasDescription
                updateQuestion(q)
              }}
              disabled={!isPriority}
            >
              {question.hasDescription ? 'Remove ' : 'Add '} Description{' '}
            </Link>

            <Divider orientation="vertical" variant="middle" flexItem />

            <WbFileUpload
              setImageName={url => {
                updateQuestion({
                  ...question,
                  image: url,
                  followupQuestions: [...question.followupQuestions],
                  questionSettings: {...question.questionSettings},
                  multiOptionResponseAttributes: [
                    ...question.multiOptionResponseAttributes,
                  ],
                })
              }}
            ></WbFileUpload>
          </Stack>
        </Grid>
      </Grid>
      {question.hasDescription && (
        <Grid container alignItems="center">
          <Grid item lg={11} md={11} sm={11} xs={11}>
            <WbTextField
              value={
                audience === AUDIENCE.STAFF
                  ? question.staffDescription
                  : audience === AUDIENCE.PARENT
                    ? question.parentDescription
                    : question.pupilDescription
              }
              label="Enter your description"
              onChange={e => {
                let q = question
                if (isPriority) {
                  if (audience === AUDIENCE.STAFF) {
                    if (q.pupilDescription === q.staffDescription)
                      q.pupilDescription = e.target.value
                    if (q.parentDescription === q.staffDescription)
                      q.parentDescription = e.target.value
                    q.staffDescription = e.target.value
                  }
                  if (audience === AUDIENCE.PARENT) {
                    if (q.pupilDescription === q.parentDescription)
                      q.pupilDescription = e.target.value
                    q.parentDescription = e.target.value
                  }
                  if (audience === AUDIENCE.STUDENT) {
                    q.pupilDescription = e.target.value
                  }
                } else {
                  if (audience === AUDIENCE.STAFF)
                    q.staffDescription = e.target.value
                  if (audience === AUDIENCE.PARENT)
                    q.parentDescription = e.target.value
                  if (audience === AUDIENCE.STUDENT)
                    q.pupilDescription = e.target.value
                }
                updateQuestion(q)
              }}
            ></WbTextField>
          </Grid>
          <Grid item lg={1} md={1} sm={1} xs={1}>
            <IconButton
              onClick={e => {
                let q = question
                q.staffDescription = null
                q.parentDescription = null
                q.hasDescription = false
                q.pupilDescription = null
                updateQuestion(q)
              }}
              disabled={!isPriority}
            >
              <RemoveCircleOutline className="icon-delete" />
            </IconButton>
          </Grid>
        </Grid>
      )}

      <Grid container alignItems="center" mt={2} mb={1}>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <label>Answer Choices</label>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={6}>
          <Stack
            direction="row"
            spacing={1}
            justifyContent="end"
            alignItems="center"
          >
            <FormControlLabel
              control={
                <WbSwitch
                  size="small"
                  label="Assign numerical values"
                  onChange={handleCustomValues}
                  checked={question.hasCustomValue}
                  disabled={!isPriority}
                ></WbSwitch>
              }
              label="Assign numerical values"
            ></FormControlLabel>
            <Tooltip
              placement="right"
              arrow
              title="To help with analysis, you can choose to assign a numerical value to each answer. These are not displayed to the survey respondents "
            >
              <HelpIcon sx={{fontSize: '18px', color: '#afafaf'}} />
            </Tooltip>
          </Stack>
        </Grid>
      </Grid>
      <Grid container spacing={1} mb={1}>
        <Grid item lg={8}>
          <WbTextField
            label="Paricipants can select"
            select
            value={question.questionSettings.multiSelectOperator}
            onChange={e => {
              updateQuestion({
                ...question,
                questionSettings: {
                  ...question.questionSettings,
                  multiSelectOperator: e.target.value,
                },
                followupQuestions: [...question.followupQuestions],
                multiOptionResponseAttributes: [
                  ...question.multiOptionResponseAttributes,
                ],
              })
            }}
          >
            <MenuItem value={1} selected>
              Exactly
            </MenuItem>
            <MenuItem value={2}>At least</MenuItem>
            <MenuItem value={3}>Maximum</MenuItem>
          </WbTextField>
        </Grid>

        <Grid item lg={4}>
          <WbTextField
            select
            label="Value"
            type="number"
            value={question.questionSettings.multiSelectValue}
            onChange={e => {
              updateQuestion({
                ...question,
                questionSettings: {
                  ...question.questionSettings,
                  multiSelectValue: e.target.value,
                },
                followupQuestions: [...question.followupQuestions],
                multiOptionResponseAttributes: [
                  ...question.multiOptionResponseAttributes,
                ],
              })
            }}
          >
            {question.multiOptionResponseAttributes.map((option, e) => (
              <MenuItem value={e + 1}>{e + 1}</MenuItem>
            ))}
          </WbTextField>
        </Grid>
      </Grid>
      <Grid container spacing={1} mb={1}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Stack
            direction="row"
            mt={3}
            justifyContent="end"
            className="meta-text"
          >
            {' '}
            <Link
              href="#"
              underline="hover"
              onClick={e => setOptionType(true, false, false)}
              style={getOptionTypeStyle(question.isTextOption)}
            >
              Add Text
            </Link>
            {question.isImageOption ? getDivider() : null}
            <Link
              href="#"
              underline="hover"
              onClick={e => setOptionType(false, true, false)}
              style={getOptionTypeStyle(question.isEmojiOption)}
            >
              Add Emoji
            </Link>{' '}
            {!question.isImageOption ? getDivider() : null}
            <Link
              href="#"
              underline="hover"
              onClick={e => setOptionType(false, false, true)}
              style={getOptionTypeStyle(question.isImageOption)}
            >
              Add Image
            </Link>
          </Stack>
        </Grid>
      </Grid>
      {question.multiOptionResponseAttributes.map((option, e) =>
        OptionRow(question, updateQuestion, e, audience, isPriority)
      )}
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Button
            variant="text"
            className="add-option"
            disableRipple
            onClick={e => {
              let options = question.multiOptionResponseAttributes
              let length = options.length + 1
              let existingValues = options.map(o => o.value).filter(v => v != null)
              let nextValue = existingValues.length > 0 ? Math.max(...existingValues) + 1 : 1
              updateQuestion({
                ...question,
                multiOptionResponseAttributes: [
                  ...question.multiOptionResponseAttributes,
                  {
                    value: nextValue,
                    staffText: 'Answer ' + length,
                    pupilText: 'Answer ' + length,
                    parentText: 'Answer ' + length,
                    order: length,
                    numValue: nextValue,
                    staffImage: null,
                    pupilImage: null,
                    parentImage: null,
                    staffEmoji: null,
                    pupilEmoji: null,
                    parentEmoji: null,
                    showStaffImageLabel: true,
                    showPupilImageLabel: true,
                    showParentImageLabel: true,
                    showStaffEmojiLabel: true,
                    showPupilEmojiLabel: true,
                    showParentEmojiLabel: true,
                  },
                ],
                followupQuestions: [...question.followupQuestions],
                questionSettings: {...question.questionSettings},
              })
            }}
            disabled={
              question.multiOptionResponseAttributes.length === 10 ||
              !isPriority
            }
          >
            + Add an answer choice
          </Button>{' '}
        </Grid>
      </Grid>
    </>
  )
}

const getOptionTypeStyle = val => ({display: !val ? 'inline' : 'none'})

const OptionRow = (question, updateQuestion, i, audience, isPriority) => {
  return (
    <Grid
      container
      id={i}
      draggable
      onDragStart={e => {
        if (!isPriority) return
        e.dataTransfer.setData('text/plain', i)
        e.dataTransfer.dropEffect = 'copy'
        e.dataTransfer.effectAllowed = 'copyMove'
      }}
      onDragOver={e => {
        if (!isPriority) return
        e.preventDefault()
      }}
      onDrop={e => {
        if (!isPriority) return
        e.preventDefault()
        let from = e.dataTransfer.getData('text/plain')
        let to = i
        let options = [...question.multiOptionResponseAttributes]
        let temp = options[from]
        options[from] = options[to]
        options[to] = temp
        let ff = question.followupQuestions
        if (question.hasFollowup) {
          question.followupQuestions[0].followupValue = temp.value
        }
        options.map((o, idx) => (o.order = idx + 1))
        updateQuestion({
          ...question,
          questionSettings: {...question.questionSettings},
          followupQuestions: [...question.followupQuestions],
          multiOptionResponseAttributes: [...options],
        })
      }}
    >
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Stack direction="row" alignItems="start">
          <IconButton disabled={!isPriority} style={{cursor: 'grab'}}>
            <DragIndicator //</Grid>onPointerDown={e => controls.start(e)}
            ></DragIndicator>
          </IconButton>
          {question.isTextOption
            ? MultiOptionTextOption(
                question,
                updateQuestion,
                i,
                audience,
                isPriority
              )
            : ''}
          {question.isEmojiOption ? (
            <MultiOptionEmojiOption
              question={question}
              updateQuestion={updateQuestion}
              i={i}
              audience={audience}
              isPriority={isPriority}
            />
          ) : (
            ''
          )}
          {question.isImageOption ? (
            <MultiOptionImageOption
              question={question}
              updateQuestion={updateQuestion}
              i={i}
              audience={audience}
              isPriority={isPriority}
            />
          ) : (
            ''
          )}
          {i >= 2 ? (
            <IconButton
              onClick={e => {
                let qp = question.multiOptionResponseAttributes
                qp.splice(i, 1)
                qp.map((o, idx) => (o.order = idx + 1))
                let q = question
                q.options = [...qp]
                updateQuestion(q)
              }}
              disabled={!isPriority}
            >
              <RemoveCircleOutline className="icon-delete" />
            </IconButton>
          ) : null}
        </Stack>
      </Grid>
    </Grid>
  )
}
